import type Notification from '../../model/Notification'
import type { NotificationType } from '../../model/Notification'
import DateUtil from '../../util/DateUtil'

export type NotificationFilter = 'all' | 'unread' | 'team'
export type IconTone = 'green' | 'blue' | 'orange'

export interface NotificationDisplay {
  id: string
  read: boolean
  time: string
  isTeamRelated: boolean
  kind: 'icon' | 'avatar'
  iconTone?: IconTone
  icon?: string
  avatarInitials?: string
  avatarPhotoUrl?: string
  isLeader?: boolean
  tagTone?: 'orange' | 'blue'
  tagIcon?: string
  text: string
  sub?: string
  rm?: { value: string; unit: string; tone?: 'green' | 'blue' }
}

const GENERIC_TITLES = new Set([
  'New Activity Logged',
  'Team Badge Earned',
  'Team Badges Earned',
  'New Chat Message',
  'Gate reached',
  'Team progress',
])

const TYPE_META: Record<
  NotificationType,
  { icon: string; tone: IconTone; team: boolean }
> = {
  ACTIVITY_LOGGED: { icon: 'mdi:run', tone: 'green', team: true },
  TEAM_BADGE_EARNED: { icon: 'mdi:star', tone: 'orange', team: true },
  GATE_REACHED: { icon: 'mdi:flag-checkered', tone: 'orange', team: true },
  CHECKPOINT_REACHED: { icon: 'mdi:map-marker', tone: 'blue', team: true },
  TEAM_CHAT: { icon: 'mdi:chat', tone: 'blue', team: true },
  HQ: { icon: 'mdi:bullhorn', tone: 'orange', team: false },
}

function displayText(notification: Notification): { text: string; sub?: string } {
  if (GENERIC_TITLES.has(notification.title)) {
    return { text: notification.message }
  }
  return { text: notification.title, sub: notification.message }
}

export function toNotificationDisplay(notification: Notification): NotificationDisplay {
  const meta = TYPE_META[notification.type]
  const { text, sub } = displayText(notification)

  return {
    id: notification.id,
    read: notification.read,
    time: DateUtil.getRelativeTimeString(notification.createdAt),
    isTeamRelated: meta.team,
    kind: 'icon',
    iconTone: meta.tone,
    icon: meta.icon,
    text,
    sub,
  }
}

export function groupNotifications(items: NotificationDisplay[]) {
  const unread = items.filter((item) => !item.read)
  const read = items.filter((item) => item.read)
  return { unread, read }
}

export function filterNotifications(
  items: NotificationDisplay[],
  filter: NotificationFilter,
): NotificationDisplay[] {
  if (filter === 'unread') return items.filter((item) => !item.read)
  if (filter === 'team') return items.filter((item) => item.isTeamRelated)
  return items
}
